import { defineMessage } from 'services/localization';

export const messages = {
    allowToCreateNewVendors: defineMessage('allow_to_create_new_vendors'),
};
